// 設定ファイルを読み込む
import devConfig from "../scripts/config/emails.dev.json";
import prodConfig from "../scripts/config/emails.prod.json";

export const ADMIN_EMAILS: string[] = [
  "kanri@qol-net.co.jp",
  // "test1@qol-net.co.jp",
  // "test1@demo-net.co.jp",
];

export const SHARED_HQ_ADMIN_EMAILS: string[] = [
  "test1@qol-net.co.jp",
  "test1@demo-net.co.jp",
];

function normEmail(email: string): string {
  return email.trim().toLowerCase();
}

/** フル本部管理者（初期データ・社員番号マスタ CRUD 等） */
export function isFullAdminEmail(email: string | undefined | null): boolean {
  if (!email) return false;
  const n = normEmail(email);
  return ADMIN_EMAILS.some((e) => normEmail(e) === n);
}

/** フル本部または共有本部（勤務薬剤師届出書等の本部向け操作） */
export function isHqStaffEmail(email: string | undefined | null): boolean {
  if (!email) return false;
  const n = normEmail(email);
  return (
    ADMIN_EMAILS.some((e) => normEmail(e) === n) ||
    SHARED_HQ_ADMIN_EMAILS.some((e) => normEmail(e) === n)
  );
}

// VITE_ENVに基づいて設定を選択
const env = import.meta.env.VITE_ENV;
let earlyReleaseEmails: string[];

if (env === "prod" || env === "production") {
  earlyReleaseEmails = prodConfig.earlyReleaseEmails;
} else if (env === "dev" || env === "development") {
  earlyReleaseEmails = devConfig.earlyReleaseEmails;
} else {
  // VITE_ENVが未定義の場合は、デフォルト値を使用
  earlyReleaseEmails = ["palao@demo-net.co.jp", "takumi@demo-net.co.jp", "hirosaki@demo-net.co.jp", "sapporohigashi@demo-net.co.jp"];
}

// 先行リリース対象のメールアドレスリスト（管理者以外で勤務薬剤師関連機能を表示するユーザー）
export const EARLY_RELEASE_EMAILS: string[] = earlyReleaseEmails;

export const BACKEND_API_URL = import.meta.env.VITE_BACKEND_API_URL;
// ステップを定数として定義
export const INITIAL_STEP = 0;
export const PROCESS_STEP = 1;
export const COMPLETION_STEP = 2;
export const NO_UNPROCESSED_FILES_STEP = 3;
export const ERROR_STEP = 4;
